module.exports = __webpack_public_path__ + "img/fin-form.826fcfd4.svg";